import { render } from "./ProductsListPage.vue?vue&type=template&id=0f44bb2b&scoped=true&ts=true"
import script from "./ProductsListPage.vue?vue&type=script&lang=ts"
export * from "./ProductsListPage.vue?vue&type=script&lang=ts"

import "./ProductsListPage.vue?vue&type=style&index=0&id=0f44bb2b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f44bb2b"]])

export default __exports__